import { Comparison, stringToAst } from '@/components/RunsTable/filter/ast';

import {
  SessionFilter,
  SessionFilterComparator,
  SessionFilterField,
} from '../types/SessionsFilterModel';

export function parseQueryString(query: string | undefined): SessionFilter[] {
  const filters: SessionFilter[] = [];
  if (!query) {
    return filters;
  }

  const ast = stringToAst(query);

  // Helper function to process a comparison and add it to filters if valid
  const processComparison = (comparison: Comparison) => {
    // Only process name field comparisons (matching original function)
    if (
      comparison.identifier === 'name' &&
      (comparison.comparator === 'eq' || comparison.comparator === 'neq')
    ) {
      filters.push({
        comparator: comparison.comparator as SessionFilterComparator,
        field: SessionFilterField.NAME,
        value: comparison.argument,
      });
    }
  };

  // Recursive function to process operations and extract comparisons
  const processAst = (node: any) => {
    if (!node) return;

    if ('comparator' in node) {
      processComparison(node as Comparison);
    } else if ('operator' in node) {
      node.operands.forEach((operand: any) => {
        processAst(operand);
      });
    }
  };

  // Process the AST recursively
  processAst(ast);

  return filters;
}
